import { FunctionComponent } from 'react';
import { Checkbox, FormControlLabel, FormGroup } from '@mui/material';
import { ProductEnvironment } from '@/models/product';
import { FlexContainer } from '@/components/Layout/Container';

type ProductEnvironmentFieldProps = {
    values: ProductEnvironment[];
    onChange: (environments: ProductEnvironment[]) => void;
};

export const ProductEnvironmentField: FunctionComponent<
    ProductEnvironmentFieldProps
> = ({ values, onChange }) => {
    const handleChange = (environment: ProductEnvironment) => () => {
        if (values.includes(environment)) {
            const envIndex = values.indexOf(environment);

            const copyValues = [...values];

            copyValues.splice(envIndex, 1);
            onChange(copyValues);
        } else {
            onChange([...values, environment]);
        }
    };

    return (
        <FlexContainer column>
            <FormGroup
                sx={{
                    display: 'flex',
                    flexDirection: 'row',
                }}
            >
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(ProductEnvironment.PORTAL)}
                            checked={values?.includes(
                                ProductEnvironment.PORTAL
                            )}
                            defaultChecked
                        />
                    }
                    label='Portal'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(
                                ProductEnvironment.INTEGRATION
                            )}
                            checked={values?.includes(
                                ProductEnvironment.INTEGRATION
                            )}
                            defaultChecked
                        />
                    }
                    label='Integration'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(ProductEnvironment.B2B)}
                            checked={values?.includes(ProductEnvironment.B2B)}
                            defaultChecked
                        />
                    }
                    label='B2B'
                />
                <FormControlLabel
                    control={
                        <Checkbox
                            onChange={handleChange(ProductEnvironment.MOBILE)}
                            checked={values?.includes(
                                ProductEnvironment.MOBILE
                            )}
                            defaultChecked
                        />
                    }
                    label='Smartphone'
                />
            </FormGroup>
        </FlexContainer>
    );
};
